import React from "react";
import Home from "./Home";
import About from "./About";
import Work from "./Work";
import Project from "./Project";
import SecurityArchitecture from "../components/SecurityArchitecture";
import Tech from "./Tech";
import Awards from "./Awards";
import Journey from "./Journey";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

export default function Main() {
  return (
    <main style={{ backgroundColor: "var(--bg-primary)" }}>
      <Home />
      <About />
      <Work />
      <Project />
      <SecurityArchitecture />
      <Tech />
      <Awards />
      <Journey />
      <ContactSection />
      <Footer />
    </main>
  );
}

